const CropQuery = (id) => {
    return `
    query {
      deleteCrop(id: "${id}")
    } 
    `
}

export default CropQuery